// extracted by mini-css-extract-plugin
export default {"walkCont":"Walk_walkCont__j04m7","iframe":"Walk_iframe__0F82N","spinner":"Walk_spinner__gtRFI"};